import type { Control, FieldValue, UseFormSetValue } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import type { FC } from 'react';
import { Fragment, useState } from 'react';
import { styled } from '@mui/material/styles';
import { useLocaleCodeIsoNorma } from 'utils/hooks';
import { isObjectEmpty } from 'utils/typeChecks.ts';
import { TextField } from '../../mui/common/TextField.tsx';
import { sanitizeNumericInput } from 'utils/validations/sanitizeNumericInput.ts';

const InputWrapper = styled('div')(() => ({
  width: '100%',
  height: '44px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

interface CatalogueWidgetEditableTextProps {
  control: Control;
  inputName: string;
  // eslint-disable-next-line
  setValue: UseFormSetValue<FieldValue<any>>;
  // eslint-disable-next-line
  viewItem: any;
  handleSetCatalogData?: (filedName: string, value: string | number) => void;
}

export const CatalogueWidgetEditableText: FC<CatalogueWidgetEditableTextProps> = ({
  control,
  inputName,
  viewItem,
  setValue,
  handleSetCatalogData,
}) => {
  const locale = useLocaleCodeIsoNorma();
  const [isEditing, setIsEditing] = useState(true);

  return (
    <Fragment key={JSON.stringify(viewItem?.visibilityResults?.formItemUiDefinition)}>
      <Controller
        control={control}
        name={viewItem?.name}
        render={({ field, fieldState: { error } }) => {
          const isNumber = viewItem?.itemSchema?.type === 'number';

          const isEmpty = field.value === '{}' || isObjectEmpty(field.value);
          const formattedValue = isNumber && new Intl.NumberFormat(locale).format(Number(field.value ?? 0));

          const handleFormatedValue = () => {
            if (isNumber) {
              setIsEditing(true);
              setValue(inputName, field?.value);
            }
          };

          return (
            <InputWrapper>
              <TextField
                {...field}
                key={viewItem}
                sx={{
                  width: '100px',
                  '& .MuiInputBase-root': {
                    height: '40px',
                  },
                }}
                value={isEmpty ? '' : ((isNumber ? (isEditing ? field.value : formattedValue) : field.value) ?? '')}
                type={'text'}
                error={Boolean(error)}
                helperText={error?.message}
                fullWidth
                onFocus={handleFormatedValue}
                onClick={handleFormatedValue}
                onBlur={(event) => {
                  setIsEditing(false);
                  setValue(field.name, event.target.value);
                  handleSetCatalogData?.(field.name, event.target.value);
                  field.onBlur();
                }}
                onChange={(e) => {
                  if (isNumber) {
                    const inputValue = sanitizeNumericInput(e.target.value);
                    setValue(field.name, inputValue);
                    field.onChange(inputValue);
                  } else {
                    setValue(field.name, e.target.value);
                    field.onChange(e.target.value);
                  }
                }}
                slotProps={{
                  htmlInput: {
                    sx: { textAlign: 'center' },
                    ...(isNumber ? { inputMode: 'decimal' as const } : {}),
                  },
                }}
                viewItem={viewItem}
                formItemUiDefinition={viewItem?.visibilityResults?.formItemUiDefinition}
              />
            </InputWrapper>
          );
        }}
      />
    </Fragment>
  );
};
